var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.value, persistent: "", width: "800" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "pl-5 pr-2 pt-4 pb-2" },
            [
              _c(
                "v-icon",
                { staticClass: "mr-2", attrs: { color: "warning" } },
                [_vm._v("mdi-alert")]
              ),
              _c("div", { staticClass: "title h6" }, [
                _vm._v(" Existing Ads Detected "),
              ]),
              _c(
                "v-card-subtitle",
                {
                  staticClass: "py-2 pl-0 pr-2 ma-0",
                  staticStyle: { "word-break": "break-word" },
                },
                [
                  _vm._v(
                    " Do you want to replace the existing ads for the groups below as part of the shuttle? "
                  ),
                ]
              ),
            ],
            1
          ),
          _c("v-divider", { staticClass: "mx-4" }),
          _c(
            "v-container",
            { staticClass: "pa-0 mx-0", attrs: { fluid: "" } },
            [
              _c("v-data-table", {
                staticClass: "mx-4",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.ads,
                  dense: "",
                  height: _vm.tableHeight,
                  "fixed-header": "",
                  "footer-props": { "items-per-page-options": [-1] },
                  "items-per-page": -1,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.ad_start_date`,
                      fn: function ({ item }) {
                        return [
                          item.ad_start_date
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dateConfig.formatDate(
                                        item.ad_start_date
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                    {
                      key: `item.ad_end_date`,
                      fn: function ({ item }) {
                        return [
                          item.ad_end_date
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$dateConfig.formatDate(
                                        item.ad_end_date
                                      )
                                    )
                                ),
                              ])
                            : _c("span", [_vm._v("-")]),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
              }),
              _c(
                "div",
                { staticClass: "mt-4 d-flex justify-center" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "ml-4",
                      attrs: { text: "" },
                      on: { click: _vm.close },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4 mr-4",
                      attrs: { outlined: "" },
                      on: {
                        click: function ($event) {
                          return _vm.confirm(false)
                        },
                      },
                    },
                    [_vm._v(" No, Keep Existing Ads ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mb-4 mr-4",
                      attrs: { color: "warning" },
                      on: {
                        click: function ($event) {
                          return _vm.confirm(true)
                        },
                      },
                    },
                    [_vm._v(" Yes, Replace ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }